/**
 * Fork of text-and-numbers.directives.js’ cfn-input-[integer|double|area] directives:
 * Calls the change method only once *after* the input field’s value has been changed (on blur).
 *
 * d-input-integer, d-input-double and d-input-area shall from now on be used in all new or updated code.
 * The 'cfn-' equivalents are hereby deprecated.
 */

var inputInteger = 'dInputInteger';
var inputDouble = 'dInputDouble';
var inputArea = 'dInputArea';

registerNumericInputDirective(inputInteger);
registerNumericInputDirective(inputDouble);
registerNumericInputDirective(inputArea);

function registerNumericInputDirective(inputType) {
  angular.module('cfn').directive(inputType, [
    '$rootScope',
    '$log',
    'unitConverter',
    'userSettingsService',
    '$locale',
    function($rootScope, $log, unitConverter, userSettingsService, $locale) {
      return {
        restrict: 'E',
        scope: {
          model: '=',
          class: '@',
          readonly: '=',
          required: '@',
          param: '@', //display decimal places
          symbolPre: '@',
          symbolPost: '@',
          symbolPostSingular: '@',
          defaultValue: '@',

          unitFactor: '@',
          vMin: '@',
          vMax: '@',
          change: '&',
          asep: '=' // thousands separator
        },
        replace: true,
        template:
          '<input style="text-align:right" type="text" cfn-enter-tab ng-class="{\'validate[required]\':required&&(readonly!=true)}" class="{{class}}" ng-readonly="readonly" ng-required="{{required}}"/>',
        // TODO: Compare with https://gist.github.com/kwokhou/5964296
        //     - fromUser/toUser could be handled by auto-numeric?
        //     - check if auto-caluclated currency fields still work
        link: function(scope, element, attrs, ngModel, $parse) {
          if (_.isUndefined(scope.param)) {
            scope.param = 2;
          }

          if (inputType === inputInteger) {
            scope.param = 0;
          } else if (inputType === inputArea) {
            scope.param = unitConverter.unitDefaultDecimals(
              userSettingsService.getAreaUnitEnum()
            );
          }

          /* Note: the autonumeric makes some things very complex. you need to update into both directions !*/
          /* Autonumeric is a jquery plugin: http://www.decorplanit.com/plugin/ */
          var autoNumOptions = {
            aSep: !_.isUndefined(scope.asep)
              ? scope.asep
              : $locale.NUMBER_FORMATS.GROUP_SEP,
            aDec: $locale.NUMBER_FORMATS.DECIMAL_SEP,
            mDec: scope.param,
            vMin: scope.vMin || '-9999999999999.99',
            vMax: scope.vMax || '999999999999999.99'
          };
          element.autoNumeric('init', autoNumOptions);

          var updateSymbol = function() {
            // check if the element does even exist anymore
            if (!element.autoNumeric('getSettings')) return;
            if (scope.symbolPre && scope.symbolPre.length > 0) {
              element.autoNumeric('update', {
                aSign: scope.symbolPre,
                pSign: 's'
              });
            } else {
              if (scope.symbolPost && scope.symbolPost.length > 0) {
                if (
                  scope.symbolPostSingular &&
                  scope.symbolPostSingular.length > 0 &&
                  scope.model == 1
                ) {
                  // if there is a singular symbol and model value is 1, use singular
                  element.autoNumeric('update', {
                    aSign: ' ' + scope.symbolPostSingular,
                    pSign: 's'
                  });
                } else {
                  // use plural / default symbol
                  element.autoNumeric('update', {
                    aSign: ' ' + scope.symbolPost,
                    pSign: 's'
                  });
                }
              } else {
                element.autoNumeric('update', {
                  aSign: ''
                });
              }
            }
          };

          scope.$watch("symbolPre+' '+symbolPost", updateSymbol);

          if (attrs.model) {
            scope.set = function(value) {
              ang.apply(scope, function() {
                if (isNaN(value)) {
                  value = undefined;
                }
                scope.model = value;
              });
            };
            scope.get = function() {
              return scope.model;
            };
          }

          // update the model when the data is changed

          if (attrs.model) {
            var changeEventByKeyUp = false;
            var getUserdata = function(event) {
              var changed = true;
              ang.apply(scope, function() {
                // convert the number from user space to model space
                var v = element.autoNumeric('get');
                v = parseFloat(v);
                if (inputType === inputArea) {
                  //convert from model unit space (hectar) to user one
                  v = unitConverter.convert(
                    userSettingsService.getAreaUnitEnum(),
                    'AREAL_HA',
                    v
                  );
                }

                if (isNaN(v)) {
                  v = scope['default'];
                }
                // check if the value was empty before. If it was empty allow NaN and undefined to be equal
                if (v === 0) {
                  if (_.isUndefined(scope.model) || isNaN(scope.model)) {
                    changed = false;
                  }
                }

                if (!changed || scope.model === v) {
                  changed = false;
                }
                scope.model = v;
              });

              if (event === null) {
                // event is a keyup event, no real change event
                if (changed) changeEventByKeyUp = true;
              } else if (changed || changeEventByKeyUp) {
                // either if the change
                ang.apply(scope, function() {
                  if (scope.change) scope.change();
                });
              } else {
                return false;
              }
            };
            element.change(getUserdata);

            var displayUpdate = function() {
              //model got change update view
              var val = scope.model;

              if (isNaN(scope.model)) {
                scope.model = undefined;
              }

              if (
                _.isUndefined(scope.model) &&
                !_.isUndefined(scope.defaultValue) &&
                !_.isNull(scope.defaultValue)
              ) {
                val = scope.model = scope.defaultValue;
              }

              // update symbol when there is a singular symbol that can be used
              if (
                scope.symbolPostSingular &&
                scope.symbolPostSingular.length > 0
              ) {
                updateSymbol();
              }

              if (inputType === inputArea) {
                //convert from user unit space to model one (hectar)
                val = unitConverter.convert(
                  'AREAL_HA',
                  userSettingsService.getAreaUnitEnum(),
                  val
                );
              }

              // if the model changes, update the  autonumeric value
              if (!_.isUndefined(val) && !_.isNull(val)) {
                try {
                  element.autoNumeric('set', val);
                } catch (e) {
                  $log.error(
                    'exception occured in input. Maybe scope is wrong? ' + val,
                    e,
                    element,
                    element[0]
                  );
                  // Workaround: If used in a popup, a change of the shown element
                  // leads to an uninitialized component on which set
                  // must not be called. Catch this exception for now.
                  //                    element.autoNumeric('set',"");
                }
              } else {
                try {
                  element.autoNumeric('set', '');
                } catch (e) {
                  $log.error(
                    'exception occured in input. Maybe scope is wrong? ' + val,
                    e,
                    element,
                    element[0]
                  );
                  // Workaround: If used in a popup, a change of the shown element
                  // leads to an uninitialized component on which set
                  // must not be called. Catch this exception for now.
                  //                    element.autoNumeric('set',"");
                }
              }
            };
            var unwatchModel = scope.$watch('model', displayUpdate);
            if (attrs.unitFactor) {
              scope.$watch('unitFactor', displayUpdate);
            }
          } // if model
        } // end link function
      };
    }
  ]);
}
